<div class="template-container">
  <cam-loader [isLoading]="this.requestState.isLoading()">
    @if (this.currentItem.department && this.currentItem.professions) {
      <cam-department-professions
        class="ta-c"
        [professions]="this.currentItem.professions"
      ></cam-department-professions>
    }

    @if (this.form(); as form) {
      @if (!this.requestState.isLoading()) {
        <div class="form">
          <cam-form
            [inputs]="form"
            [canDisplayButton]="false"
            [askValidation$]="this.askValidation$"
            (valid)="this.send($event)"
          >
          </cam-form>
        </div>
      }
    }

    <div class="cta">
      <div class="row">
        <div class="col-6">
          <cam-button (action)="this.cancel()" [style]="'danger'">
            {{ 'core.communicationhandler.template.cancel' | translate }}
          </cam-button>
        </div>
        <div class="col-6">
          <cam-button (action)="this.askValidation()">
            {{ 'core.communicationhandler.template.send' | translate }}
          </cam-button>
        </div>
      </div>
    </div>
  </cam-loader>
</div>
